import React, { useState, useEffect } from "react";
import home from "../assets/home.png";
import "../css/MapLeftSideBar.css";

export default function MapLeftSideBar(props) {
  const title = "Location";
  const { currentProperty } = props.redux;

  return (
    <div
      className="mapLeftSideBarWrapper"
      style={
        props.backgroundStyle === true
          ? props.activeBackground
          : props.inactiveBackground
      }
    >
      <React.Fragment>
        <div className="header">
          <h1>
            <strong>
              <a>{title}</a>
            </strong>
          </h1>
        </div>
        <div className="basicHomeCosts">
          <div className="rightMapSection">
            <p>
              <strong>Address: {currentProperty.GeoAddress}</strong>
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Built: </strong>

              {currentProperty.Built}
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Bedrooms: </strong> {currentProperty.Bed}
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Bathrooms: </strong>
              {currentProperty.Bath}
              /mo
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <span>Square Footage: </span>

              {currentProperty.SqFt}
            </p>
          </div>
        </div>
        <div className="specialistInfo">
          <div className="rightMapSection">
            <p>
              <strong>Lot Size: </strong> {currentProperty.LotSize}
            </p>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
}
